import { Box, IconButton, Menu } from "@mui/material";
import { styled as StyledMui } from "@mui/material/styles";
import { Link } from "react-router-dom";

export const MobileNavigationMenuBox = StyledMui(Box)(() => ({
  flexGrow: 1,
  display: "none",
  "@media only screen and (max-width: 850px)": {
    display: "flex",
  },
}));

export const MobileNavigationMenuIcon = StyledMui(IconButton)(({ theme }) => ({
  color: theme.trueWhite.main,
  border: `2px solid ${theme.trueWhite.main}`,
  borderRadius: "5px",
}));

export const MobileNavigationStyledMenu = StyledMui(Menu)(({ theme }) => ({
  display: "none",
  "@media only screen and (max-width: 850px)": {
    display: "block",
    ul: { backgroundColor: theme.bniRed.main },
  },
}));

export const MobileNavLink = StyledMui(Link)(({ theme, selected }) => ({
  color:
    String(selected) === "true"
      ? theme.trueWhite.main
      : "rgba(255, 255, 255, 0.85)",
  textDecoration: "none",
  borderBottom:
    String(selected) === "true" && `3px solid ${theme.trueWhite.main}`,
  fontWeight: "700",
}));